import React from 'react';

// A text as its sentences: a sentence ends at a full stop, question or exclamation mark outside quotes, or at the
// closing quote after one, when a space and a capital letter or an opening quote follow.
export const split_into_sentences = (text)=>{
	const source = String(text);
	const sentences = [];
	let current = '';
	let in_quote = false;
	for(var char_index = 0; char_index < source.length; ++char_index){
		const character = source[char_index];
		current += character;
		if(character === '"'){
			in_quote = !in_quote;
		}

		const ends_sentence = !in_quote && (/[.!?]/.test(character) || ((character === '"') && /[.!?]/.test(source[char_index - 1])));
		if(ends_sentence && /^\s+["'A-Z]/.test(source.substring(char_index + 1))){
			sentences.push(current.trim());
			current = '';
		}
	}

	if(current.trim().length > 0){
		sentences.push(current.trim());
	}

	return sentences;
};

// Lines each on a line of its own, so no box holds a wall of text. Each line is text or rendered content.
export const render_sentence_lines = (lines)=>{
	return lines.map((line, line_index)=>{
		return (
			<span className="sentence-line" key={line_index}>{line}</span>
		);
	});
};

// A text one sentence per line.
export const render_text_lines = (text)=>{
	return render_sentence_lines(split_into_sentences(text));
};
